import React from "react";
import "./TxnLookup.css";

function PayInModal({ modalData, setOpenModal }) {
  // console.log("modalDatamodalData",modalData)
  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>{"Payment Details"}</h3>
        <div className="dialog-data">
          <p>
            <span>Amount-</span>₹
            {modalData && modalData.requestData && modalData.requestData.amount}
          </p>
          <p>
            <span>Customer Name- </span>
            {modalData &&
              modalData.requestData &&
              modalData.requestData.customerName ||
              modalData.requestData.beneEmail}
          </p>

          <p>
            <span>Customer Mobile - </span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.customerMobile ||
              modalData.requestData.beneMobile}
          </p>

          <p>
            <span>Customer Email - </span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.customerEmail &&
              modalData?.requestData?.customerEmail || modalData?.requestData?.beneEmail}
          </p>
          <p>
            <span>Order ID- </span>
            {modalData &&
              modalData.requestData &&
              modalData.orderId &&
              modalData.orderId}
          </p>
          <p>
            <span>Customer VPA - </span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.vpa &&
              modalData.requestData.vpa}
          </p>
          <p>
            <span>Transaction Mode- </span>
            {modalData &&
              modalData.requestData &&
              modalData.requestData.transactionMode ||
              modalData.requestData.mode}
          </p>
          <p>
            <span>Transaction Id- </span>
            {modalData && modalData.transactionId && modalData.transactionId || "N/A"} 
          </p>
          <p>
            <span>Ref Id- </span>
            {modalData && modalData.referenceId && modalData.referenceId}
          </p>
            <p>
              <span>UTR- </span>
              {modalData?.responseData?.UTR ?? 'N/A'}
            </p>
          <p>
            <span>RESPONSE MESSAGE- </span>
            {modalData &&
              modalData.responseData &&
              modalData.responseData.RESPONSE_MESSAGE &&
              modalData.responseData.RESPONSE_MESSAGE}
          </p>
          <p>
            <span>RESPONSE VPA- </span>
            {modalData &&
              modalData.responseData &&
              modalData.responseData.vpa &&
              modalData.responseData.vpa}
          </p>
        </div>

        <div className="modal-button">
          <button className="view-btn-1" onClick={() => setOpenModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default PayInModal;
